import React from "react";
import { IoHomeOutline } from "react-icons/io5";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";

const Sozlesmeler = ({ title, sections, hideDate }) => {
  return (
    <div className="containerMain flex flex-col gap-8 ">
      <div className="baslik flex flex-col gap-4">
        <h1 className="text-2xl font-bold text-dark">{title}</h1>
        <div className="text-sm text-grayy flex items-center gap-2 font-medium">
          <IoHomeOutline className="w-4 h-4" />
          <Link to="/">Anasayfa</Link>
          <MdOutlineKeyboardArrowRight className="w-6 h-6" />
          <span className="text-darkerGreen">{title}</span>
        </div>
      </div>

      <div
        className="container flex flex-col gap-4 max-h-[634px] overflow-y-auto "
        style={{
          scrollbarWidth: "thin",
          scrollbarColor: "grayy",
          overflowX: "hidden",
        }}
      >
        <div className="p-2 flex flex-col items-center gap-4">
          <h1 className="text-center text-dark text-2xl sm:text-4xl font-bold leading-[40px]">
            {title}
          </h1>
        </div>
        {sections.map((section, index) => (
          <div key={index} className="flex flex-col">
            {section.type === "table" ? (
              <>
                <h2
                  className={section.className || "text-base font-medium px-2"}
                >
                  {section.heading}
                </h2>
                {section.component}
              </>
            ) : (
              (!hideDate || !section.className?.includes("tarih")) && (
                <>
                  <h2
                    className={`${
                      section.className || "text-base font-medium px-2"
                    }`}
                  >
                    {section.heading}
                  </h2>
                  <br></br>
                  {Array.isArray(section.text) ? (
                    section.text.map((paragraph, pIndex) => (
                      <p
                        key={pIndex}
                        className="p-2 text-sm text-grayy font-normal leading-[22px]"
                      >
                        {paragraph.includes("<strong>") ? (
                          <span
                            dangerouslySetInnerHTML={{ __html: paragraph }}
                          />
                        ) : (
                          paragraph
                        )}
                      </p>
                    ))
                  ) : (
                    <p className="p-2 text-sm text-grayy font-normal leading-[22px]">
                      {section.text}
                    </p>
                  )}
                </>
              )
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sozlesmeler;
